(function () {
  if (window.crossSellHandlersInitialized) return;
  window.crossSellHandlersInitialized = true;

  function decodeLookImages(panel) {
    if (!panel || panel.dataset.decoded === 'true') return Promise.resolve();

    const images = Array.from(panel.querySelectorAll('img'));
    const videos = Array.from(panel.querySelectorAll('video'));
    const decodes = images.map(function (img) {
      if (typeof img.decode === 'function') return img.decode().catch(function () {});
      if (img.complete) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    }).concat(videos.map(function (video) {
      if (video.readyState >= 2) return Promise.resolve();
      return new Promise(function (resolve) {
        video.addEventListener('loadeddata', resolve, { once: true });
        video.addEventListener('error', resolve, { once: true });
      });
    }));

    return Promise.all(decodes).then(function () {
      panel.dataset.decoded = 'true';
    });
  }

  function setLookExpanded(toggle, panel, expanded) {
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.classList.toggle('is-open', expanded);
    panel.setAttribute('aria-hidden', String(!expanded));

    if (expanded) {
      panel.removeAttribute('inert');
      panel.querySelectorAll('video').forEach(function (video) {
        video.play().catch(function () {});
      });
    } else {
      panel.setAttribute('inert', '');
      panel.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });
    }

    const nextLabel = expanded ? toggle.dataset.labelCollapse : toggle.dataset.labelExpand;
    if (nextLabel) toggle.setAttribute('aria-label', nextLabel);
  }

  function getVisibleLookMedia(panel) {
    const media = panel.querySelectorAll('img, video');
    for (var i = 0; i < media.length; i++) {
      const rect = media[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return media[i];
    }
    return panel;
  }

  function ensureLookMediaInView(panel) {
    const media = getVisibleLookMedia(panel);
    if (!media) return;

    const header = document.querySelector('sticky-header');
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    const topGutter = Math.max(headerBottom, 0) + 12;
    const bottomGutter = 12;
    const rect = media.getBoundingClientRect();

    if (rect.height === 0 || rect.width === 0) return;

    var delta = 0;
    if (rect.top < topGutter) {
      delta = rect.top - topGutter;
    } else if (rect.bottom > window.innerHeight - bottomGutter) {
      delta = rect.bottom - (window.innerHeight - bottomGutter);
      if (rect.top - delta < topGutter) {
        delta = rect.top - topGutter;
      }
    }

    if (Math.abs(delta) < 1) return;

    window.scrollBy({ top: delta, behavior: 'smooth' });
  }

  function afterLookExpand(panel) {
    var ran = false;
    function run() {
      if (ran) return;
      ran = true;
      requestAnimationFrame(function () {
        ensureLookMediaInView(panel);
      });
    }

    panel.addEventListener('transitionend', function (event) {
      if (event.target === panel) run();
    }, { once: true });
    setTimeout(run, 400);
  }

  function toggleLookImage(toggle) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      setLookExpanded(toggle, panel, false);
      return;
    }

    decodeLookImages(panel).then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          setLookExpanded(toggle, panel, true);
          afterLookExpand(panel);
        });
      });
    });
  }

  function showError(block, message) {
    const error = block.querySelector('.cross-sell-block__error');
    if (!error) return;

    error.textContent = message;
    error.removeAttribute('hidden');
  }

  function clearError(block) {
    const error = block.querySelector('.cross-sell-block__error');
    if (!error) return;

    error.textContent = '';
    error.setAttribute('hidden', '');
  }

  function trackLookBundleAdded(block, items) {
    var cards = block.querySelectorAll('.cross-sell-card[data-cross-sell-variant-id]');
    var itemNames = [];
    var itemSkus = [];
    var variantIds = [];

    cards.forEach(function (card) {
      if (card.dataset.crossSellProductTitle) itemNames.push(card.dataset.crossSellProductTitle);
      if (card.dataset.crossSellProductSku) itemSkus.push(card.dataset.crossSellProductSku);
      if (card.dataset.crossSellVariantId) variantIds.push(card.dataset.crossSellVariantId);
    });

    var properties = {
      LookName: block.dataset.lookName || '',
      ProductName: block.dataset.lookProductTitle || '',
      ProductID: block.dataset.lookProductId || '',
      ProductHandle: block.dataset.lookProductHandle || '',
      URL: block.dataset.lookProductUrl || window.location.pathname,
      DiscountPercent: Number(block.dataset.lookDiscountPercent) || 0,
      ItemCount: items.length,
      ItemNames: itemNames.join(', '),
      ItemSKUs: itemSkus.join(', '),
      VariantIDs: variantIds.join(', '),
    };

    var email = block.dataset.klaviyoEmail;
    var identity = email ? { email: email, $email: email } : null;

    function sendTrack() {
      if (!window.klaviyo) return false;

      try {
        if (identity && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify(identity);
        } else if (identity && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(['identify', identity]);
        }

        if (typeof window.klaviyo.track === 'function') {
          window.klaviyo.track('Added Look Bundle', properties);
          return true;
        }

        if (typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(['track', 'Added Look Bundle', properties]);
          return true;
        }
      } catch (e) {}

      return false;
    }

    if (sendTrack()) return;

    window._klOnsite = window._klOnsite || [];
    if (identity) window._klOnsite.push(['identify', identity]);
    window._klOnsite.push(['track', 'Added Look Bundle', properties]);

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (sendTrack() || attempts > 20) clearInterval(timer);
    }, 250);
  }

  function lookIdFromBlock(block) {
    return block.dataset.lookProductHandle || window.location.pathname;
  }

  function addAllItems(block, addAllButton) {
    if (addAllButton.getAttribute('aria-disabled') === 'true') return;

    clearError(block);

    const cards = block.querySelectorAll('.cross-sell-card[data-cross-sell-variant-id]');
    const items = [];

    cards.forEach(function (card) {
      const variantId = Number(card.dataset.crossSellVariantId);
      if (!variantId) return;

      const properties = {
        _source_section: 'pdp_cross_sell',
        _source_pdp: card.dataset.crossSellSourcePdp || window.location.pathname,
      };
      if (card.dataset.crossSellApplyDiscount === 'true' && card.dataset.crossSellPropertyName) {
        properties[card.dataset.crossSellPropertyName] = 'true';
      }

      items.push({
        id: variantId,
        quantity: 1,
        properties: properties,
      });
    });

    if (!items.length) {
      showError(block, 'No products are currently available.');
      return;
    }

    var lookHandle = lookIdFromBlock(block);
    var lookId = lookHandle + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var lookSize = String(items.length);
    items.forEach(function (item) {
      item.properties._look_id = lookId;
      item.properties._look_handle = lookHandle;
      item.properties._look_size = lookSize;
    });

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    const body = { items: items };

    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    config.body = JSON.stringify(body);

    const spinner = addAllButton.querySelector('.loading-overlay__spinner');

    addAllButton.setAttribute('aria-disabled', 'true');
    addAllButton.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          const message = response.description || response.message || window.cartStrings?.error;
          showError(block, message || 'Unable to add these products. Please try again.');
          return;
        }

        trackLookBundleAdded(block, items);

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cross-sell-add-all' });
        }

        // Items are already in the cart at this point, so a render fault must not be
        // reported to the shopper as a failed add.
        try {
          cart.renderContents(response);
        } catch (e) {
          console.error(e);
        }

        try {
          if (window.bfTheme && window.bfTheme.syncDiscountFromCart) window.bfTheme.syncDiscountFromCart();
        } catch (e) {}

        try {
          window.bfTheme?.recalculateAllPrices?.();
        } catch (e) {}

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function (error) {
        console.error(error);
        showError(block, window.cartStrings?.error || 'Unable to add these products. Please try again.');
      })
      .finally(function () {
        addAllButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        addAllButton.removeAttribute('aria-disabled');
      });
  }

  document.querySelectorAll('.cross-sell-block__look-panel').forEach(decodeLookImages);

  function productListFromEvent(event) {
    var el = eventElement(event);
    return el && el.closest ? el.closest('.cross-sell-block__products') : null;
  }

  function productListCanScroll(list) {
    return list.scrollHeight > list.clientHeight + 1;
  }

  function productListAtTop(list) {
    return list.scrollTop <= 0;
  }

  function productListAtBottom(list) {
    return list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
  }

  function productListShouldPassToPage(list, deltaY) {
    if (!productListCanScroll(list)) return true;
    if (deltaY > 0 && productListAtBottom(list)) return true;
    if (deltaY < 0 && productListAtTop(list)) return true;
    return false;
  }

  var lastProductListTouchY = 0;

  function eventElement(event) {
    var target = event.target;
    if (!target) return null;
    if (typeof target.closest === 'function') return target;
    return target.parentElement || null;
  }

  document.addEventListener('wheel', function (event) {
    if (event.ctrlKey) return;

    var list = productListFromEvent(event);
    if (!list || !productListShouldPassToPage(list, event.deltaY)) return;

    window.scrollBy({ top: event.deltaY, left: event.deltaX });
  }, { passive: true, capture: true });

  document.addEventListener('touchstart', function (event) {
    if (!event.touches.length || !productListFromEvent(event)) return;
    lastProductListTouchY = event.touches[0].clientY;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (event) {
    var list = productListFromEvent(event);
    if (!list || !event.touches.length) return;

    var currentY = event.touches[0].clientY;
    var deltaY = lastProductListTouchY - currentY;
    lastProductListTouchY = currentY;

    if (!productListShouldPassToPage(list, deltaY)) return;

    event.preventDefault();
    window.scrollBy(0, deltaY);
  }, { passive: false, capture: true });

  document.addEventListener('pointerenter', function (event) {
    const el = eventElement(event);
    if (!el) return;

    const toggle = el.closest('.cross-sell-block__look-toggle');
    if (!toggle) return;

    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    decodeLookImages(panel);
  }, true);

  document.addEventListener(
    'click',
    function (event) {
      const el = eventElement(event);
      if (!el) return;

      const toggle = el.closest('.cross-sell-block__look-toggle');
      if (toggle) {
        event.preventDefault();
        toggleLookImage(toggle);
        return;
      }

      const addAllButton = el.closest('.cross-sell-block__add-all');
      if (!addAllButton) return;

      event.preventDefault();
      const block = addAllButton.closest('[data-section="pdp-cross-sell"]');
      if (block) addAllItems(block, addAllButton);
    },
    true
  );
})();
